import React, { useEffect, useState } from 'react'
import AppIcon from '../common/AppIcon'
import { NumberInput } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import AppInputWrapper from './AppInputWrapper'
import { useDebouncedCallback } from '@mantine/hooks'

interface CustomProps
  extends Omit<React.ComponentPropsWithoutRef<typeof NumberInput>, 'onChange'> {
  type: 'currency' | 'year' | 'quantity' | 'import' | 'default'
  entity?: string
  name: string
  value?: string
  icon?: string
  onChange?: any
  w?: string | number
  leftSection?: React.ReactNode
  label?: string
  labelh?: string
  placeholder?: string
  debounced?: boolean
  local?: boolean
  // colorInput?: string
}

const AppNumberInput = ({
  type,
  entity = 'calc',
  name,
  value,
  icon = 'text',
  onChange,
  w = '100%',
  label,
  labelh,
  placeholder,
  debounced = true,
  local = true,
  // colorInput,
  ...otherProps
}: CustomProps) => {
  const { t } = useTranslation()
  const [localValue, setLocalValue] = useState<number | string | null>(
    value ? value : null,
  )

  useEffect(() => {
    setLocalValue(value || null)
  }, [value])

  const debouncedOnChange = useDebouncedCallback(
    (v: string | number) => {
      onChange?.({
        target: { name, value: v },
      })
    },
    300, // milisegundos de debounce
  )

  const localProps = () => {
    if (type === 'quantity')
      return {
        thousandSeparator: '.',
        decimalScale: 0,
        fixedDecimalScale: false,
        max: 9999,
        min: 0,
        maxLength: 4,
      }
    if (type === 'year')
      return {
        thousandSeparator: '',
        decimalScale: 0,
        fixedDecimalScale: false,
        max: 3000,
        min: 1900,
        maxLength: 4,
      }
  }

  return (
    <AppInputWrapper w={w} label={label}>
      {labelh && t(labelh)}
      <NumberInput
        {...otherProps}
        {...localProps()}
        w={w}
        hideControls
        label={label && t(label)}
        value={local ? localValue : value}
        onChange={(_value) => {
          if (local) setLocalValue(_value)
          if (onChange) {
            if (debounced) debouncedOnChange(_value)
            else onChange(_value)
          }
        }}
        leftSectionPointerEvents="none"
        leftSection={<AppIcon icon={entity} />}
        placeholder={t(placeholder)}
      />
    </AppInputWrapper>
  )
}

export default AppNumberInput
